function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.89878 5.15483C4.90441 5.1495 4.90666 5.1424 4.91228 5.13707L8.83939 1.71163C9.05875 1.51891 9.05875 1.20629 8.83939 1.01357C8.83714 1.01179 8.83489 1.01091 8.83264 1.01002C8.78383 0.963353 8.72271 0.925664 8.65354 0.899586C8.58436 0.873508 8.50881 0.85967 8.43216 0.859039L0.57683 0.859039C0.498774 0.860035 0.421946 0.87455 0.351776 0.901559C0.281605 0.928568 0.219802 0.967412 0.170732 1.01535L0.168483 1.01357C0.0623239 1.11054 0.00390625 1.23443 0.00390625 1.3626C0.00390625 1.49077 0.0623239 1.61466 0.168483 1.71163L4.10459 5.15483C4.15359 5.20018 4.21447 5.23659 4.28302 5.26156C4.35158 5.28653 4.42618 5.29947 4.50168 5.29947C4.57719 5.29947 4.65179 5.28653 4.72034 5.26156C4.7889 5.23659 4.84978 5.20018 4.89878 5.15483Z",
  fill: "#646972"
});

var SvgChevronDown = function SvgChevronDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChevronDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ChevronDown.f860ce32.svg";
export { ForwardRef as ReactComponent };